// P20M-1308 follow-up — drop any collapsible section that has no visible filters left, so an
// admin who hides every filter inside a section doesn't leave an empty, clickable dropdown.
// Sections without a `collapsed` array (single / proximity / calendars) always keep their one
// control, so they are never dropped.
export const dropEmptyFilterSections = (tabs = []) =>
  tabs.filter((tab) => {
    if (!tab) return false;
    if ((tab.type === 'multiple' || tab.type === 'double') && !tab.collapsed?.length) return false;
    return true;
  });
